import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from './contexts/AuthContext';
import { onResume } from './utils/api';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import './main.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchInterval: 60_000,
      refetchOnWindowFocus: true,
      retry: 2,
    },
  },
});

// When the user returns after a long sleep (phone standby, laptop lid),
// invalidate all queries so React Query refetches with no stale ETag.
onResume(() => {
  queryClient.invalidateQueries();
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <QueryClientProvider client={queryClient}>
          <ErrorBoundary>
            <App />
          </ErrorBoundary>
        </QueryClientProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
